module.exports = __webpack_public_path__ + "media/images/flags/16/Bhutan-f839c66d59f33bb3f81d9b9cc2d6def5.png";